import LockWithCheckmark from '../../src/legacy/LockWithCheckmark.tsx';
export default LockWithCheckmark;
